import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  // estilo pill do prototipo: rounded-full, mono uppercase 10px com tracking
  'inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 font-mono text-[10px] font-medium uppercase leading-[1.4] tracking-[0.08em] transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground',
        secondary: 'bg-secondary text-secondary-foreground',
        destructive: 'bg-destructive text-destructive-foreground',
        outline: 'border border-border text-muted-foreground',
        soft: 'bg-primary-soft text-primary',
        success: 'bg-success/15 text-success',
        warning: 'bg-warning/20 text-foreground',
        // ---- aliases visuais do prototipo (PT-BR) ----
        hoje: 'bg-primary text-primary-foreground',
        prox: 'bg-primary-soft text-primary',
        feito: 'bg-success/15 text-success',
        atrasado: 'bg-destructive text-destructive-foreground',
        pendente: 'bg-muted text-muted-foreground',
        muted: 'bg-muted text-muted-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
